// extracted by mini-css-extract-plugin
module.exports = {"segment-chart-container":"segment-chart_segment-chart-container__1bHzc"};